import { ScadaFreeText, ScadaLabel, ScadaProps } from "components/dashboard/scada/scadaTypes";
import { useComponentStoreContext } from "components/fragments/dashboard/components/context/ComponentProvider";
import useDashboardStore from "store/dashboard-store";
import useTabId from "./dashboard/useTabId";

type Scada = {
  elements?: ScadaLabel[];
  freeTexts?: ScadaFreeText[];
};

const useUpdateScadaConfig = () => {
  const dashboard = useDashboardStore(state => state.dashboard);
  const updateComponent = useDashboardStore(state => state.updateComponent);
  const tabId = useTabId();

  const store = useComponentStoreContext();

  const updateScadaConfig = (scada: Scada) => {
    if (!store || !dashboard || !dashboard.dashboardTabsJs) return;

    const state = store.getState();
    const componentId = state?.componentId;
    const groupId = state?.groupId;
    const currentTab = dashboard.dashboardTabsJs[tabId];

    if (!currentTab) return;

    const componentGroup = currentTab.componentGroups.find(group => group.id === groupId);

    const updatedComponent = componentGroup?.components.find(component => component.id === componentId);

    if (updatedComponent) {
      updatedComponent.config = { ...updatedComponent.config, ...scada } as ScadaProps;
      updateComponent(groupId, componentId, updatedComponent, tabId);
    }
  };

  return updateScadaConfig;
};

export default useUpdateScadaConfig;
